import React, { CSSProperties, ReactNode, ComponentProps } from 'react';
import { useFela } from '../..';
import { WithTheme } from '../../Theme';

export type ListProps = DmListProps &
  Omit<ComponentProps<'ol'>, keyof DmListProps>;

interface DmListProps {
  /**
   * data-dmid, kann mehrfach belegt werden (z.B. für Tests)
   */
  dmId?: string;
  /**
   * Boolean, um eine nummerierten Liste darzustellen.
   */
  ordered?: boolean;
  /**
   * Objekt, um Styling der List anzupassen.
   * Davon darf nur im Ausnahmefall Gebrauch gemacht werden!
   */
  style?: CSSProperties | object;
  /**
   * Child-Elemente (ListItems)
   */
  children: ReactNode;
}

const defaultStyle = ({ theme }: WithTheme) => ({
  paddingLeft: theme.dimension.spacing.l.rem,
  margin: 0,
  color: theme.palette.color2.hex,
});

const List = ({
  dmId = 'dm-list',
  ordered,
  style,
  ...otherProps
}: ListProps): JSX.Element => {
  const { css } = useFela();
  if (ordered) {
    return (
      <ol
        data-designsystem
        data-dmid={dmId}
        className={css([defaultStyle, style])}
        {...otherProps}
      />
    );
  }
  return (
    <ul
      data-designsystem
      data-dmid={dmId}
      className={css([defaultStyle, style])}
      {...otherProps}
    />
  );
};

export default List;
